<template>
    <div>
        <div v-if="done == false">
            <div class="form-group">
                <label for="newpass1">Jaunā parole</label>
                <input id="newpass1" type="password" v-model="newpass1" class="form-control" :class="{'is-invalid':errors && ( 'newpass1' in errors)}">
                <small class="text-danger" v-if="errors && errors.newpass1">{{errors.newpass1[0]}}</small>
            </div>
            <div class="form-group">
                <label for="newpass2">Jaunā parole (atkārtoti)</label>
                <input id="newpass2" type="password" v-model="newpass2" class="form-control" :class="{'is-invalid':errors && ( 'newpass2' in errors)}">
                <small class="text-danger" v-if="errors && errors.newpass2">{{errors.newpass2[0]}}</small>
            </div>
            <div class="form-group text-right">
                <input type="button" class="btn btn-primary" v-if="loading == false" @click="resetPassword(user.id, token)" value="Saglabāt"/>
                <button type="button" class="btn btn-primary"  v-if="loading == true"><i class="fas fa-spinner fa-spin"></i></button>
            </div>
        </div>
        <div v-else>
            <div class="text-center">
                <a href="/login" class="btn btn-primary">Ienākt sistēmā</a>
            </div>

        </div>

    </div>

</template>
<script>
export default{
    props:['user','token'],
    data(){
        return {
            errors:[],
            newpass1:"",
            newpass2:"",
            loading:false,
            done:false,

        }
    },
    methods:{
        resetPassword(userID, token)
        {
            this.loading = true;
            var that = this;
            axios.post('/password/reset/'+userID+'/'+token,{
                newpass1: that.newpass1,
                newpass2: that.newpass2,
                token:token,
                userID:userID
            }).then(response => {
                if (response.data.status == 'error') {
                    that.loading = false;
                    that.errors = response.data.errors;
                    that.$toast.open({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
                if (response.data.status == 'success')
                {
                    that.loading = false;
                    that.$toast.open({
                        message: response.data.message,
                        type: 'success'
                    });
                    that.done = true;
                }
            });

        }
    }

}
</script>
<style lang="scss">

</style>
